if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      colorChoiceMade = false;

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }

      async connectedCallback() {
  await customElements.whenDefined('product-form');
  customElements.upgrade(this);

  this.initializeProductSwapUtility();

        try {
  this.initializeRequiredColor();
} catch (error) {
  window.alert('Fout bij kleurstart: ' + error.message);
  throw error;
}



        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.dispatchEvent(
          new CustomEvent('product-info:loaded', { bubbles: true })
        );
      }

      getColorControls() {
        return Array.from(
          this.querySelectorAll('variant-selects [data-option-name]')
        ).filter(
          (element) => element.dataset.optionName === 'Kleur tegel'
        );
      }

      initializeRequiredColor() {
        if (!this.getColorControls().length) return;

        this.dataset.requiresColorChoice = 'true';
        this.dataset.colorChoiceReady = 'false';
        this.colorChoiceMade = false;

        this.clearColorSelection();
        this.setPaymentButtonsVisible(false);
        this.productForm?.toggleSubmitButton(true, 'Kies eerst een kleur');
      }

      clearColorSelection() {
        const controls = this.getColorControls();

        controls.forEach((element) => {
          if (element.matches('input[type="radio"]')) {
            element.checked = false;
          }
        });

        const colorSelect = controls
          .find((element) => element.tagName === 'OPTION')
          ?.closest('select');

        if (colorSelect) {
          let placeholder = colorSelect.querySelector(
            '[data-color-placeholder]'
          );

          if (!placeholder) {
            placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Kies een kleur';
            placeholder.disabled = true;
            placeholder.dataset.colorPlaceholder = 'true';
            colorSelect.prepend(placeholder);
          }

          colorSelect.value = '';
          placeholder.selected = true;
        }

        const group = controls[0]?.closest(
          'fieldset, .product-form__input'
        );
        const selectedLabel = group?.querySelector('[data-selected-value]');

        if (selectedLabel) {
          if (selectedLabel.classList.contains('dropdown-swatch')) {
            selectedLabel.replaceChildren();
          } else {
            selectedLabel.textContent = 'Kies een kleur';
          }
        }
      }

      setPaymentButtonsVisible(visible) {
        this.querySelectorAll('.shopify-payment-button').forEach((button) => {
          button.hidden = !visible;

          if (visible) {
            button.style.removeProperty('display');
          } else {
            button.style.setProperty('display', 'none', 'important');
          }
        });
      }

      updateRequiredColorState(variant) {
        if (this.dataset.requiresColorChoice !== 'true') return;

        const ready = Boolean(this.colorChoiceMade && variant?.id);
        this.dataset.colorChoiceReady = String(ready);
        this.setPaymentButtonsVisible(ready);

        if (!this.colorChoiceMade) {
          this.clearColorSelection();
        }

        if (!ready) {
          this.productForm?.toggleSubmitButton(true, 'Kies eerst een kleur');
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) => {
          html.querySelectorAll('.scroll-trigger').forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
          });
        });

        this.postProcessHtmlCallbacks.push(() => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
  data: { event, target, selectedOptionValues },
}) {
  
  if (!this.contains(event.target)) return;


        if (this.dataset.requiresColorChoice === 'true') {
          const candidates = [
            target,
            event.target,
            event.target?.selectedOptions?.[0],
            target?.selectedOptions?.[0],
          ];

          const isColorSelection = candidates.some(
            (element) =>
              element?.dataset?.optionName === 'Kleur tegel'
          );

          if (isColorSelection) {
            this.colorChoiceMade = true;
          }

          this.dataset.colorChoiceReady = 'false';
          this.setPaymentButtonsVisible(false);
        }

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;

        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        this.productForm?.toggleSubmitButton(true);
        this.productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : 'product-info';

          const sourceProductInfo = html.querySelector(selector);
          const variant = this.getSelectedVariant(sourceProductInfo);

          this.variantSelectors?.resolvePendingSelectPromise(
            variant,
            this.getVariantSelects(sourceProductInfo)
          );

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML =
              html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;

            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            callback(html);
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
window.alert(
  'Fout bij variantkeuze: ' +
  (error?.message || String(error))
);

            }

            this.variantSelectors?.rejectPendingSelectPromise(error);
          });
      }

      parseJsonScript(parent, selector) {
        try {
          return JSON.parse(parent?.querySelector(selector)?.textContent);
        } catch {
          return null;
        }
      }

      getVariantSelects(queryRoot) {
        return queryRoot?.querySelector('variant-selects');
      }

      getSelectedVariant(productInfoNode) {
        return this.parseJsonScript(
          this.getVariantSelects(productInfoNode),
          '[data-selected-variant]'
        );
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        if (!shouldFetchFullPage) {
          params.push(`section_id=${this.sectionId}`);
        }

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');

        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const sourceVariantSelects = this.getVariantSelects(html);
          const variant = this.getSelectedVariant(html);

          this.variantSelectors?.resolvePendingSelectPromise(
            variant,
            sourceVariantSelects
          );

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            this.updateRequiredColorState(null);
            return;
          }

          if (
            this.dataset.requiresColorChoice !== 'true' ||
            this.colorChoiceMade
          ) {
            this.updateMedia(html, variant?.featured_media?.id);
          }

          const updateSourceFromDestination = (
            id,
            shouldHide = () => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination(
            'Sku',
            ({ classList }) => classList.contains('hidden')
          );
          updateSourceFromDestination(
            'Inventory',
            ({ innerText }) => innerText === ''
          );
          updateSourceFromDestination('Volume');
          updateSourceFromDestination(
            'Price-Per-Item',
            ({ classList }) => classList.contains('hidden')
          );

          this.updateQuantityRules(this.sectionId, html);

          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove('hidden');

          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          this.updateRequiredColorState(variant);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, ` +
          `#product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;

          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        const variantUrl =
          `${url}${variantId ? `?variant=${variantId}` : ''}`;

        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${variantUrl}`
        );

        if (this.dataset.updateUrl === 'false') return;

        window.history.replaceState({}, '', variantUrl);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          'price',
          'Inventory',
          'Sku',
          'Price-Per-Item',
          'Volume-Note',
          'Volume',
          'Quantity-Rules',
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');

        document.querySelectorAll(selectors).forEach(({ classList }) => {
          classList.add('hidden');
        });
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector('media-gallery ul');

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) {
            enableZoomOnHover(2);
          }

          const items = Array.from(
            mediaGallerySource.querySelectorAll('li[data-media-id]')
          );

          const itemSet = new Set(
            items.map((item) => item.dataset.mediaId)
          );

          const itemMap = new Map(
            items.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );

          return [items, itemSet, itemMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [sourceItems, sourceSet, sourceMap] = refreshSourceData();

          const destinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );

          const destinationSet = new Set(
            destinationItems.map((item) => item.dataset.mediaId)
          );

          let shouldRefresh = false;

          for (let i = destinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(destinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(destinationItems[i]);
              shouldRefresh = true;
            }
          }

          for (let i = 0; i < sourceItems.length; i++) {
            if (!destinationSet.has(sourceItems[i].dataset.mediaId)) {
              sourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          if (shouldRefresh) {
            [sourceItems, sourceSet, sourceMap] = refreshSourceData();
          }

          destinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(
                  `li:nth-of-type(${destinationIndex + 1})`
                )
              );

              [sourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        this.querySelector('media-gallery')?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        const modalContent = this.productModal?.querySelector(
          '.product-media-modal__content'
        );

        const newModalContent = html.querySelector(
          'product-modal .product-media-modal__content'
        );

        if (modalContent && newModalContent) {
          modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step
            ? parseInt(this.quantityInput.step)
            : 1,
        };

        let min = data.min;
        const max =
          data.max === null ? data.max : data.max - data.cartQuantity;

        if (max !== null) min = Math.min(min, max);

        if (data.cartQuantity >= data.min) {
          min = Math.min(min, data.step);
        }

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }

        this.quantityInput.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          '.quantity__rules-cart .loading__spinner'
        ).classList.remove('hidden');

        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}` +
          `&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((error) => console.error(error))
          .finally(() => {
            this.querySelector(
              '.quantity__rules-cart .loading__spinner'
            ).classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );

        const selectors = [
          '.quantity__input',
          '.quantity__rules',
          '.quantity__label',
        ];

        for (const selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated?.querySelector(selector);

          if (!current || !updated) continue;

          if (selector === '.quantity__input') {
            const attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'step',
            ];

            for (const attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);

              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;

            if (selector === '.quantity__label') {
              const labelledBy = updated.getAttribute('aria-labelledby');

              if (labelledBy) {
                current.setAttribute('aria-labelledby', labelledBy);

                const currentHiddenLabel = document.getElementById(labelledBy);
                const updatedHiddenLabel = html.getElementById(labelledBy);

                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent =
                    updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      get productModal() {
        return document.querySelector(
          `#ProductModal-${this.dataset.section}`
        );
      }

      get pickupAvailability() {
        return this.querySelector('pickup-availability');
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const sectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );

        return document.querySelector(
          `product-recommendations[data-section-id^="${sectionId}"]`
        );
      }

      get quickOrderList() {
        const sectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );

        return document.querySelector(
          `quick-order-list[data-id^="${sectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
